import { LinkButton } from "@stadium/shared/src/components/shared/button";
import { HELP_CENTER_URL } from "@stadium/constants/routes";
import styles from "./main.module.scss";

const HelpCenterLink = ({ eventLocationAnalytics }) => {
  return (
    <LinkButton
      styleType="link"
      href={HELP_CENTER_URL}
      className={styles.profileHelpButton}
      eventLocationAnalytics={eventLocationAnalytics}
      target="_blank"
    >
      <span className={styles.iconHelp}></span>
      <span className={styles.profileHelpButtonText}>Help Center</span>
    </LinkButton>
  );
};

export default HelpCenterLink;
